import { Flex } from "@chakra-ui/layout";
import telasBg from "assets/images/telas-bg.png";
import { useBreadcrumb } from "features/breadcrumbs";
import { useRegrasTenant } from "../../../../core/features/tenants/tenants.context";
import DashboardBase from "./DashboardBase";
import DashboardSubtenants from "./DashboardSubtenants";

function DashboardPage() {
  useBreadcrumb([
    {
      name: "Dashboard",
    },
  ]);

  const { useSubtenantsViews } = useRegrasTenant();

  return (
    <>
      <Flex
        minH="100vh"
        pb={4}
        flex={1}
        bgColor="#f2f2f2"
        bgImage={telasBg}
        bgPos="left bottom"
        bgSize="100% 550px"
        bgRepeat="no-repeat"
        overflowY="auto"
        justifyContent="center"
      >
        {useSubtenantsViews ? <DashboardSubtenants /> : <DashboardBase />}
      </Flex>
    </>
  );
}

export default DashboardPage;
